<template>
  <v-card class="mx-auto" width="475" outlined @click="onClick(filePath)" :style="`border-color: ${color}`">
    <v-badge :content="messages" :value="messages" :color="badgeColor" inline>
      <v-list-item two-line style="height: 55px; min-height: 55px">
        <v-list-item-icon class="pt-0 mt-2">
          <v-icon size="38" :color="color">{{ icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content class="py-1">
          <div class="caption">{{ category }}</div>
          <v-list-item-title class="text-h6">{{ name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-badge>
  </v-card>
</template>

<script>
import { Storage } from '@/plugins/storage'

export default {
  name: 'BtnManualDownLoad',

  components: {},

  props: {
    category: {
      type: String,
      required: false,
      default: '',
    },
    icon: {
      type: String,
      reuqired: true,
    },
    color: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    messages: {
      type: String,
      required: false,
      default: '',
    },
    badgeColor: {
      type: String,
      required: false,
      default: 'info',
    },
    filePath: {
      type: String,
      required: true,
    },
  },

  methods: {
    async onClick(filePath) {
      try {
        Storage.downloadFile(filePath)
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0337') })))
      }
    },
  },
}
</script>
